/**
 * GHL chat widget — loaded as a theme asset so the source never sits in HTML.
 * Safari / in-app WebViews parse <script> inside <template> as HTML and dump
 * tryFix() onto the page next to the 20% popup. This file cannot leak that way.
 */
(function () {
  var WIDGET_ID = '67ba4307a81d1c1883d76dc9';
  var LOADER = 'https://beta.leadconnectorhq.com/loader.js';
  var RESOURCES = 'https://beta.leadconnectorhq.com/chat-widget/loader.js';

  var lightCss =
    'chat-widget{pointer-events:none!important}' +
    'chat-widget .lc_text-widget,chat-widget .lc_text-widget *,' +
    'chat-widget [class*="chat-bubble"],chat-widget [class*="chat-bubble"] *{pointer-events:auto!important}';

  var shadowCss = [
    ':host{pointer-events:none!important}',
    '.lc_text-widget,.lc_text-widget *,[class*="chat-bubble"],[class*="chat-bubble"] *{pointer-events:auto!important}',
    '@media (max-width:749px){',
    '.lc_text-widget--bubble,button.lc_text-widget--bubble,.lc_text-widget[class*="bubble"],[class*="chat-bubble"]{bottom:72px!important}',
    '}'
  ].join('');

  function addCss() {
    if (document.getElementById('gtm-ghl-light-css')) return;
    var s = document.createElement('style');
    s.id = 'gtm-ghl-light-css';
    s.textContent = lightCss;
    document.head.appendChild(s);
  }

  /* fixes1 2026-09-25: lift the bubble above a visible fixed sticky bar (#gtm-scta / #gl-scta) so it never covers the bar's close x */
  function gtmChatBottom() {
    var b = 72, bars = document.querySelectorAll('#gtm-scta.gtm-scta--show, #gl-scta:not(.gl-scta--hide)');
    for (var i = 0; i < bars.length; i++) {
      var cs = getComputedStyle(bars[i]);
      if (cs.display === 'none' || cs.position !== 'fixed' || !bars[i].offsetHeight) continue;
      b = Math.max(b, Math.round((parseFloat(cs.bottom) || 0) + bars[i].offsetHeight + 10));
    }
    return b;
  }
  window.gtmLiftChat = function () { try { tryFix(); } catch (e) {} };

  function liftBubble(root) {
    if (!root || window.innerWidth > 749) return;
    var bubble = root.querySelector('.lc_text-widget--bubble, button.lc_text-widget--bubble, [class*="chat-bubble"]');
    if (bubble) bubble.style.setProperty('bottom', gtmChatBottom() + 'px', 'important');
  }

  function inject(root) {
    if (!root) return false;
    if (!root.querySelector('style[data-gtm-chat-fix]')) {
      var s = document.createElement('style');
      s.setAttribute('data-gtm-chat-fix', '1');
      s.textContent = shadowCss;
      root.appendChild(s);
    }
    liftBubble(root);
    return !!root.querySelector('.lc_text-widget--bubble, button.lc_text-widget--bubble, [class*="chat-bubble"]');
  }

  function tryFix() {
    var nodes = document.querySelectorAll('chat-widget');
    var done = false;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot && inject(nodes[i].shadowRoot)) done = true;
    }
    return done;
  }

  function watch() {
    var obs = new MutationObserver(function () { tryFix(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    var ticks = 0;
    var okStreak = 0;
    var t = setInterval(function () {
      ticks++;
      if (tryFix()) okStreak++; else okStreak = 0;
      if (okStreak >= 8 || ticks >= 80) {
        clearInterval(t);
        obs.disconnect();
      }
    }, 250);
    tryFix();
    window.addEventListener('resize', function () { tryFix(); });
  }

  function loadWidget() {
    if (document.querySelector('script[data-gtm-ghl-loader]')) return;
    var s = document.createElement('script');
    s.src = LOADER;
    s.async = true;
    s.setAttribute('data-gtm-ghl-loader', '1');
    s.setAttribute('data-resources-url', RESOURCES);
    s.setAttribute('data-widget-id', WIDGET_ID);
    document.body.appendChild(s);
  }

  function boot() {
    addCss();
    loadWidget();
    watch();
  }

  var started = false;
  function start() {
    if (started) return;
    started = true;
    boot();
  }

  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, start, { once: true, passive: true });
  });
  if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 6000 });
  else setTimeout(start, 5000);
})();
